import React from "react";
import {Scrollbars} from "react-custom-scrollbars";

// Thin, always-visible scrollbar (it used to hide until you scrolled, and its default dark
// thumb disappeared on dark backgrounds). Colours come from .custom-scroll-thumb, per theme.
const CustomScrollbars = ({autoHide = false, ...props}) => (
    <Scrollbars
        {...props}
        autoHide={autoHide}
        renderTrackHorizontal={trackProps => <div {...trackProps} style={{display: 'none'}} className="track-horizontal"/>}
        renderTrackVertical={({style, ...trackProps}) => (
            <div {...trackProps} className="custom-scroll-track" style={{...style, right: 2, bottom: 2, top: 2, width: 6, borderRadius: 3}}/>
        )}
        renderThumbVertical={({style, ...thumbProps}) => (
            <div {...thumbProps} className="custom-scroll-thumb" style={{...style, borderRadius: 3}}/>
        )}
    />
);

export default CustomScrollbars;
